import { render } from "./HeroiconsSolidSortDescending.vue?vue&type=template&id=8bdd6142"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSortDescending.vue"]])

export default __exports__